export default __webpack_public_path__ + "static/media/sydney-opera-house-near-beautiful-sea-clear-blue-sky.f1c13f8b.jpg";